import React, { useState, useEffect, useContext, createContext } from 'react';

interface CompactModeContextType {
    compactMode: boolean;
    toggleCompactMode: () => void;
}

const CompactModeContext = createContext<CompactModeContextType>({
    compactMode: false,
    toggleCompactMode: () => {},
});

const getInitialCompactMode = (): boolean => {
    try {
        const saved = localStorage.getItem('compactMode');
        if (saved !== null) {
            return JSON.parse(saved) === true;
        }
    } catch {
        // ignore corrupted localStorage value
    }
    return false;
};

export const CompactModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [compactMode, setCompactMode] = useState(getInitialCompactMode);

    useEffect(() => {
        localStorage.setItem('compactMode', JSON.stringify(compactMode));
    }, [compactMode]);

    const toggleCompactMode = () => setCompactMode(prev => !prev);

    return (
        <CompactModeContext.Provider value={{ compactMode, toggleCompactMode }}>
            {children}
        </CompactModeContext.Provider>
    );
};

export const useCompactMode = () => {
    return useContext(CompactModeContext);
};
